import Clarity from '@microsoft/clarity';
import { useUserStore } from '@/stores/user';

export default defineNuxtPlugin((nuxtApp) => {
    const id = nuxtApp.$config.public.clarityId
    const featureEnabled = nuxtApp.$config.public.features.clarity
    const useClarityInImpersonationMode = nuxtApp.$config.public.features.clarityInImpersonationMode;
    const userStore = useUserStore()
    
    if(!useClarityInImpersonationMode && userStore.isImpersonating) {
        console.log("Clarity is not loaded in impersonation mode")
        return;
    }
    
    // Only initialize if ID is present and feature is enabled
    if (id && featureEnabled) {
        Clarity.init(id)
        console.log('Clarity initialized')
    } else {
        console.log('Clarity disabled (no ID provided)')
    }
})